import dayjs from "dayjs";
import utcPlugin from "dayjs/plugin/utc";
dayjs.extend(utcPlugin);

export const postPackingFormUrl =
  "https://us-central1-packers-node.cloudfunctions.net/api/packing/";
export const downloadPDFUrl =
  "https://us-central1-packers-node.cloudfunctions.net/api/packing/download/";
export const getFurnitureUrl =
  "https://us-central1-packers-node.cloudfunctions.net/api/packing-details/";

export const postManageFormUrl =
  "https://us-central1-packers-node.cloudfunctions.net/api/packing-details";

export const updateAmountPackingUrl =
  "https://us-central1-packers-node.cloudfunctions.net/api/packing/amount/edit";

export const getAccessToken = () => {
  const token = localStorage.getItem("token");

  let accessToken = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return accessToken;
};

export const convertUTCToLocal = (dateOrString, format) => {
  let dateTimeIs = dayjs.utc(dateOrString).local().format(format);
  return dateTimeIs;
};

export const distanceAmountCalculation = (distance, distanceConfig) => {
  if (distance > distanceConfig.minDistance) {
    const extraDistance = distance - distanceConfig.minDistance;
    return (
      distanceConfig.minCharge + extraDistance * distanceConfig.extraChargePerKM
    );
  }
  return distanceConfig.minCharge;
};

export function parseJwt(token) {
  if (token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map((c) => `%${("00" + c.charCodeAt(0).toString(16)).slice(-2)}`)
        .join("")
    );
    return JSON.parse(jsonPayload);
  }
  return "";
}
